import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import { resetGEAccountNumbers } from '../../../redux/actions';

class Confirmation extends Component {

	componentWillMount() {
		let { registration } = this.props.state;
		if(!registration.ssoRegistrationParams) {
			//redirect to sso registration page if user directly comes on this page
			browserHistory.push("/login");
		}
		this.props.resetGEAccountNumbers();
	}

    render() {
        return (
			<div>
				<h1>Thank You for Registering on GE Appliances CustomerNet!</h1>
				<p>
					Your request has been submitted and is pending approval of the account administrator and/or your GEA Area Sales Manager.<br/>
					You will be notified via email once approved.
				</p>
			</div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	resetGEAccountNumbers: () => dispatch(resetGEAccountNumbers()),
});

Confirmation = connect(mapStateToProps, mapDispatchToProps)(Confirmation);
export default Confirmation;



// WEBPACK FOOTER //
// ./src/App/components/PreLogin/GECustNetRegistration/confirmation.js